import { Box, Typography } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var URL_REGEXP = /(https?:\/\/[^\s]+)/gi;

var extractTrailingPunctuation = function extractTrailingPunctuation(value) {
  var match = value.match(/[),.!?;:]+$/);

  if (!match) {
    return {
      pureUrl: value,
      trailingPunctuation: ''
    };
  }

  var trailingPunctuation = match[0];
  var pureUrl = value.slice(0, -trailingPunctuation.length);
  return {
    pureUrl: pureUrl,
    trailingPunctuation: trailingPunctuation
  };
};

var LinkableText = function LinkableText(_ref) {
  var content = _ref.content,
      className = _ref.className,
      linkClick = _ref.linkClick;

  if (!content) {
    return null;
  }

  var handleUrlClick = function handleUrlClick(event, url) {
    event.preventDefault();

    if (linkClick) {
      linkClick(url, event);
      return;
    }

    if (true) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  return /*#__PURE__*/_jsx(Box, {
    className: className,
    children: /*#__PURE__*/_jsx(Typography, {
      variant: "body2",
      className: "whitespace-pre-wrap break-words leading-6",
      children: content.split(URL_REGEXP).map(function (segment, index) {
        if (!/^https?:\/\//i.test(segment)) {
          return /*#__PURE__*/_jsx("span", {
            children: segment
          }, "text-".concat(index));
        }

        var _extractTrailingPunct = extractTrailingPunctuation(segment),
            pureUrl = _extractTrailingPunct.pureUrl,
            trailingPunctuation = _extractTrailingPunct.trailingPunctuation;

        return /*#__PURE__*/_jsxs("span", {
          children: [/*#__PURE__*/_jsx("a", {
            href: pureUrl,
            className: "cursor-pointer text-[#0E35D1] underline underline-offset-2",
            onClick: function onClick(event) {
              return handleUrlClick(event, pureUrl);
            },
            children: pureUrl
          }), trailingPunctuation]
        }, "url-".concat(index));
      })
    })
  });
};

export default LinkableText;